const SESIONES_ENTRENAMIENTO_1X = Object.freeze({
  // Planes de Entrenamiento
  "entrenamiento-1-vez-a-la-semana-mensual": 4,
  "entrenamiento-1-vez-a-la-semana-trimestral": 12,
  "entrenamiento-1-vez-a-la-semana-semestral": 24,

  // Entrenamiento en Pareja
  "pareja-entrenamiento-1-vez-a-la-semana-mensual": 4,
  "pareja-entrenamiento-1-vez-a-la-semana-trimestral": 12,
  "pareja-entrenamiento-1-vez-a-la-semana-semestral": 24,
});

export const obtenerSesionesEntrenamiento1x = (
  categoria,
  varianteId
) => {
  const esEntrenamiento = String(categoria || "")
    .toLowerCase()
    .includes("entren");

  const id = String(varianteId || "").trim();

  if (
    !esEntrenamiento ||
    !Object.prototype.hasOwnProperty.call(
      SESIONES_ENTRENAMIENTO_1X,
      id
    )
  ) {
    return null;
  }

  return SESIONES_ENTRENAMIENTO_1X[id];
};